import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {faEnvelope, faHeading, faPhone, faQuestionCircle, faUser} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  contactForm: FormGroup;
  faUser = faUser;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  faTitle = faQuestionCircle;

  constructor(private _fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.contactForm = this._fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.email]],
      phone: [],
      section: [],
      title: ['', [Validators.required]],
      content: ['', [Validators.required]],
    });
  }

}
